<template>
  <div class="relative steps"
       :class="classCurrentStep"
  >
    <div class="block_step">
      <div class="steps_elem"
           :style="getWidthProgressbar"
      >
        {{ getStepHeader.id + '. ' + getStepHeader.text }}
      </div>
    </div>
    <div class="steps_elem__step"
         :style="getWidthProgressbar"
    >
      {{ getStepHeader.id + ' / ' + headerPoint.length }}
    </div>
  </div>  
</template>

<script>
  import * as svgFiles from "../svgFlag";
  import {emitter} from "../../../databus";

  export default {
    name: 'HeaderPoint',

    props: {
      currentStep: { // текущий шаг
        type: Number,
        default: () => {
          return 1
        }
      },

      keyRate:{
        type: Number,
        default: () => {
          return 0
        }
      },

      typeHeaderPoint: { // тип хлебных крошек / full - полный / sliced - обрезанный
        type: String,
        default: () => {
          return 'full'
        }
      },
    },

    data() {
      return {
        isFinalEssay: false, // это итоговое сочинение?
        headerPoint: [],
        classCurrentStep: '', // класс для текущего активного шага

        key: 0,
        timer: null,
        progressbar: '',
      }
    },

    created() {
      this.key = this.keyRate;
      this.setHeaderPoints();
    },

    watch:{
      keyRate(){
        if ( this.key !== this.keyRate) {
          this.key = this.keyRate;

          for( let i = 0; i < this.headerPoint.length; i++ ) {
            if ( i !== 0 ) {
              this.hideStep(this.headerPoint[i].id)
            }
          }

          clearTimeout(this.timer);
          this.showDownload();
        }
      },

      typeHeaderPoint() {
        this.$nextTick(() => {
          this.setHeaderPoints();
        })
      },

      'getStepHeader'(after) {
        emitter.emit("isLastStep", after.id === Number(this.headerPoint.length));
      }
    },

    methods: {
      /** Возвращает тип продукта по id
       * @returns {String} тип продукта
      * */
      getTypeProduct() {
        const course = this.$store.state.allCourses[this.$route.params.idCourse];
        if (course && course.type) return course.type
        return undefined
      },

      /** Устанавливает хлебные крошки
       * */
      setHeaderPoints() {
        /** Получить массив пунктов
         * @return {Array}
         * **/
        let getHeaderPoint = () => {
          if ( !this.$store.state.auth.other.is_confirm_email &&
              !this.$store.state.auth.other.is_contract ) return [
            {
              id: 1,
              text: 'Выбор времени обучения',
              step: 3,
              show: false,
            },
            {
              id: 2,
              text: 'Выбор репетитора',
              step: 4,
              show: false,
            },
            {
              id: 3,
              text: 'Заполнение профиля',
              step: 5,
              show: false,
            },
            {
              id: 4,
              text: 'Подтверждение почты',
              step: 6,
              show: false,
            },
            {
              id: 5,
              text: 'Оформление договора',
              step: 7,
              show: false,
            }
          ];
          else if ( !this.$store.state.auth.other.is_confirm_email &&
              this.$store.state.auth.other.is_contract) return [
            {
              id: 1,
              text: 'Выбор времени обучения',
              step: 3,
              show: false,
            },
            {
              id: 2,
              text: 'Выбор репетитора',
              step: 4,
              show: false,
            },
            {
              id: 3,
              text: 'Заполнение профиля',
              step: 5,
              show: false,
            },
            {
              id: 4,
              text: 'Подтверждение почты',
              step: 6,
              show: false,
            },
          ];
          else if ( this.$store.state.auth.other.is_confirm_email &&
              !this.$store.state.auth.other.is_contract ) return [
            {
              id: 1,
              text: 'Выбор времени обучения',
              step: 3,
              show: false,
            },
            {
              id: 2,
              text: 'Выбор репетитора',
              step: 4,
              show: false,
            },
            {
              id: 3,
              text: 'Заполнение профиля',
              step: 5,
              show: false,
            },
            {
              id: 4,
              text: 'Оформление договора',
              step: 7,
              show: false,
            }
          ];
          else return [
              {
                id: 1,
                text: 'Выбор времени обучения',
                step: 3,
                show: false,
              },
              {
                id: 2,
                text: 'Выбор репетитора',
                step: 4,
                show: false,
              },
              {
                id: 3,
                text: 'Заполнение профиля',
                step: 5,
                show: false,
              },
            ];
        }

        switch (this.getTypeProduct()) {

          case 'ff':
            this.headerPoint = [
              {
                id: 1,
                svg: svgFiles.user,
                text: 'Заполнение профиля',
                step: 5,
                show: false,
              },
              {
                id: 2,
                text: 'Подтверждение почты',
                step: 6,
                show: false,
              },
            ];
            break;

          default:
            if (this.typeHeaderPoint === 'full') {
              this.headerPoint = getHeaderPoint();
              console.log("this.headerPoint", this.headerPoint)
            } else {
              this.headerPoint = [
                {
                  id: 1,
                  text: 'Заполнение профиля',
                  step: 3,
                  show: false,
                },
                {
                  id: 2,
                  text: 'Подтверждение почты',
                  step: 4,
                  show: false,
                },
              ];
            }
        }
      },

      showDownload(){
        let document2 = document.getElementById('step_download');
        document2.style.opacity = 1;

        this.timer = setTimeout(() => {
          document2.style.opacity = 0;
        }, 2000)
      },

      hideStep(id){
        let document1 = document.getElementById('steps_' + id);

        document1.style.transition = 'opacity 0.25s';
        document1.style.opacity = 0;


        setTimeout(() => {
          document1.style.opacity = 1;
        }, 2000)
      },
    },

    computed: {
      getStepHeader() {
        return this.headerPoint.find(x => x.step === this.currentStep);
      },

      getWidthProgressbar() {
        return '--width:' + Math.ceil((this.headerPoint.find(x => x.step === this.currentStep).id / this.headerPoint.length) * 100);
      },
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../style/styles_fonts";

  $font_Geometria: Geometria, 'Geometria';

  $color_background: #F6F6FB;
  $color_Gray_1: #C5C5C9;
  $color_Gray_2: #ABABB2;
  $color_Gray_3: #EBEBEB;
  $color_Gray_4:  #F9F9F9;
  $color_Gray_5: #8D909F;
  $color_Gray_6: #F2F2F2;
  $color_black: #333333;
  $color_purple: #8C71FE;
  $color_purple2: #F2F1FF;
  $color_purple3: #E2E2F6;
  $color_purple_4: #7B61EB;
  $color_purple_5:#6F57D6;
  $color_purple6: #B1A1F2;
  $color_red: #FF6597;
  $color_white: #FFFFFF;
  $color_cyan: #C0CADC;
  $color_cyan2: #AEBCD6;
  $color_green: #89CE54;
  $color_green1: #E7F5DD;

  .fade-enter-active, .fade-leave-active {
    transition: opacity ease .25s;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }

  .flex{
    display: flex;
  }

  .steps{
    height: 64px;
    position: relative;
  }

  .block_step {
    height: 100%;
    overflow: hidden;
    background: $color_white;
    border: 1px solid $color_Gray_3;
    border-radius: 16px;
  }

  .steps_elem{
    height: 100%;
    padding: 0 24px;
    position: relative;
    display: flex;
    align-items: center;
    border-right: 1px solid rgba(0, 0, 0, 0.08);
    font-family: $font_Geometria;
    font-size: 17px;
    font-weight: 500;
    line-height: 22px;
    color: $color_black;
  }

  .steps_elem__step {
    height: 20px;
    width: 40px;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: calc(0px - 8px);
    border-radius: 48px;
    left: calc((var(--width, 0) * 1%) - 20px);
    background-color: $color_purple;
    color: $color_white;
    font-family: $font_Geometria;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    transition: 0.25s linear;
  }

  .steps_elem::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 4px;
    width: calc(var(--width, 0) * 1%);
    background: $color_purple;
    transition: 0.25s linear;
  }

@media all and (max-width: 1440px) {
  .steps{
    height: 60px;
  }

  .block_step {
    border-radius: 12px;
  }

  .steps_elem{
    padding: 0 22px;
    font-size: 16px;
    line-height: 20px;
  }

  .steps_elem__step {
    height: 18px;
    width: 33px;
    bottom: calc(0px - 8px);
    left: calc((var(--width, 0) * 1%) - 17px);
    font-size: 11px;
    line-height: 13px;
  }

  .steps_elem::before {
    height: 3px;
  }
}
@media all and (max-width: 1280px) {
  .steps{
    height: 56px;
  }

  .block_step {
    border-radius: 10px;
  }

  .steps_elem{
    padding: 0 20px;
    font-size: 15px;
    line-height: 18px;
  }
}
@media all and (max-width: 1160px) {

}
@media all and (max-width: 960px) {

}
@media all and (max-width: 768px) {

}

@media all and (max-width: 700px) {

}

@media all and (max-width: 600px) {


}
</style>